module.exports = __webpack_public_path__ + "img/Loading_r_44.ba45293f.png";